import { JSX } from "react";
import schoolImage from "../../../../common/images/school-orange.svg";
import {
    TableWidget,
    EmptyWidget,
} from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useDashboardScheduledQualifications } from "../../hooks/useDashboardScheduledQualifications";

export const DashboardScheduledQualifications = (): JSX.Element => {
    const {
        loading,
        table,
        currentPage,
        itemsPerPage,
        itemsPerPageSelect,
        onPageChange,
        onItemsPerPageChange,
        title,
        isEmpty,
    } = useDashboardScheduledQualifications();

    if (loading) {
        return <Skeleton height={"35rem"} borderRadius={"1.5rem"} />;
    }

    if (isEmpty) {
        return (
            <EmptyWidget
                title={title}
                content={"Geen ingeplande opleidingen"}
                svgUrl={schoolImage}
            />
        );
    }

    return (
        <TableWidget
            data={table}
            showResultCount={true}
            totalItemsInTitle={false}
            svgUrl={schoolImage}
            title={title}
            currentPage={currentPage}
            onChange={onPageChange}
            itemsPerPage={itemsPerPage}
            itemsPerPageSelect={itemsPerPageSelect}
            onItemsPerPageChange={onItemsPerPageChange}
        />
    );
};
